module.exports = __webpack_public_path__ + "img/nara.a31b5a19.jpg";